import AbmTelefonos from "../../components/textos/AbmTelefonos/AbmTelefonos";

export const configTable = {
    urls: [
        "/Texto/GetByIdTipoTexto/4?Pagina=1&RegistrosPorPagina=-1", // GET
        "/Texto", // POST 
        "/Texto", // PUT
        "/Texto" // DELETE
    ],
    grid: {
        columnConfig: ["id","nombre", "descripcion"], 
        searchField: ["nombre", "id", "descripcion"]
    },
    Abm: AbmTelefonos,
    textSize: 10
}